import React from 'react';
import { Link } from 'react-router-dom';

const BlogPosta: React.FC = () => {
    return (
        <div className="container py-4">
            <nav className="mb-3">
                <Link to="/blogs" className="text-decoration-none small">← Back to all blogs</Link>
            </nav>

            <article className="mx-auto" style={{ maxWidth: 820 }}>
                <header className="mb-3">
                    <h1 className="display-6">Don't Wait for Tomorrow: Your Financial Dreams Need Action Today!</h1>
                    <div className="text-muted small">
                        <span>Published:</span>
                        <span className="ms-2">May, 2025</span>
                        <span className="mx-2">•</span>
                        <span>5 min read</span>
                    </div>
                </header>

                <img src="/images/bloga.webp" alt="Financial planning urgency" className="img-fluid rounded mb-4" />

                <section className="mb-3">
                    <p className="lead">We all have dreams—from a cozy retirement home to your child's education. But dreams without action remain just dreams, especially with money.</p>
                    <p>Time is your most valuable asset in financial planning. The earlier you start, the more power compounding has to work its magic. Imagine two friends, Rohan and Priya, both aiming for a ₹1 crore retirement corpus.</p>
                    <ul>
                        <li>Rohan (starts at 25): Invests ₹5,000 monthly</li>
                        <li>Priya (starts at 35): Needs significantly higher monthly investment for the same goal</li>
                    </ul>
                    <p>This isn't just hypothetical—it plays out every day. A delay of even a few years can drastically impact your ability to reach financial goals comfortably.</p>
                </section>

                <section className="mb-3">
                    <h2 className="h5">Why the urgency?</h2>
                    <ul>
                        <li><strong>The power of compounding</strong>: Your earnings generate further earnings. The longer you wait, the less time your money has to grow exponentially.</li>
                        <li><strong>Inflation doesn't wait</strong>: Costs rise. Starting early helps you build a larger, inflation-adjusted corpus—crucial for education and healthcare.</li>
                        <li><strong>Unexpected hurdles</strong>: A plan provides a safety net for emergencies without derailing long-term goals.</li>
                        <li><strong>More time for course correction</strong>: Start early to adapt to market changes and evolving goals without pressure.</li>
                    </ul>
                </section>

                <section className="mb-3">
                    <h2 className="h5">Take the first step—today</h2>
                    <p>You don't need all the answers right now. The most important thing is to start. Try this:</p>
                    <ul>
                        <li><strong>Define your goals</strong>: Retirement, education, a home—write them down.</li>
                        <li><strong>Understand your current situation</strong>: Income, expenses, and any existing investments.</li>
                        <li><strong>Start small</strong>: Even a modest, consistent SIP beats waiting for the “perfect” time.</li>
                        <li><strong>Seek guidance</strong>: A financial advisor can help align plans with your risk tolerance.</li>
                    </ul>
                </section>

                <div className="alert alert-primary" role="alert">
                    Ready to act? Try the <Link to="/calculator" className="alert-link">SIP Calculator</Link> or <Link to="/goals" className="alert-link">set a goal</Link> now.
                </div>
            </article>
        </div>
    );
};

export default BlogPosta;